import {
    LOADING_PRISTINE,
    GET_GOOGLE_PLATFORM_CLIENT_ID_URL,
    SET_GOOGLE_PLATFORM_STATE,
    LOADING_STARTED,
    LOADING_COMPLETED_SUCCESS,
    LOADING_COMPLETED_FAILURE,
    INIT_GOOGLE_PLATFORM_AUTH_2,
    SET_GOOGLE_PLATFORM_AUTH_2_STATE,
    ATTACH_GOOGLE_PLATFORM_AUTH_2_TO_ELEMENT,
    LOGIN_WITH_GOOGLE,
    SET_GOOGLE_LOGIN_STATE,
    SET_SESSION, SET_FACEBOOK_SDK_STATE,
    SET_FACEBOOK_LOGIN_STATE,
    LOGIN_WITH_FACEBOOK,
    AUTHENTICATE_WITH_FACEBOOK,

} from '../services/constants'
import http from '../services/axios'
import helpers from '../services/helpers'

const integrationsModule = {
    state: {
        google: {
            // clientId: '706289737384-jbo5b7d17h3kgbp1uissjpfphsqhscn6',
            clientId: '561753878581-prlt7lfgkhir47pv1rqkpc1v4aofviii',
            googlePlatform: {
                state: LOADING_PRISTINE,
                data: null,
                error: null,
            },
            auth2: {
                state: LOADING_PRISTINE,
                data: null,
                error: null,
            },
            login: {
                state: LOADING_PRISTINE,
                data: null,
                error: null,
            }
        },
        facebook: {
            appId: '614871595636228',
            facebookSdk: {
                state: LOADING_PRISTINE,
                data: null,
                error: null,
            },
            login: {
                state: LOADING_PRISTINE,
                data: null,
                error: null,
            }
        }
    },
    getters: {
        [GET_GOOGLE_PLATFORM_CLIENT_ID_URL](state) {
            return `${state.google.clientId}.apps.googleusercontent.com`
        },
    },
    mutations: {
        [SET_GOOGLE_PLATFORM_STATE](state, payload) {
            state.google.googlePlatform = payload
        },
        [SET_GOOGLE_PLATFORM_AUTH_2_STATE](state, payload) {
            state.google.auth2 = payload
        },
        [SET_GOOGLE_LOGIN_STATE](state, payload) {
            state.google.login = payload
        },
        [SET_FACEBOOK_SDK_STATE](state, payload) {
            state.facebook.facebookSdk = payload
        },
        [SET_FACEBOOK_LOGIN_STATE](state, payload) {
            state.facebook.login = payload
        },
    },
    actions: {
        [INIT_GOOGLE_PLATFORM_AUTH_2]: (context) => {
            context.commit(SET_GOOGLE_PLATFORM_AUTH_2_STATE, {
                state: LOADING_STARTED,
                data: null,
                error: null,
            })
            context.state.google.googlePlatform.data.load('auth2', () => {
                const auth2 = context.state.google.googlePlatform.data.auth2.init({
                    client_id: context.getters[GET_GOOGLE_PLATFORM_CLIENT_ID_URL],
                    cookiepolicy: 'single_host_origin',
                });
                context.commit(SET_GOOGLE_PLATFORM_AUTH_2_STATE, {
                    state: LOADING_COMPLETED_SUCCESS,
                    data: auth2,
                    error: null,
                })
            });
        },
        [ATTACH_GOOGLE_PLATFORM_AUTH_2_TO_ELEMENT]: (context, el) => {
            return new Promise(function (resolve, reject) {
                context.state.google.auth2.data.attachClickHandler(el, {}, function (googleUser) {
                    return context.dispatch(LOGIN_WITH_GOOGLE, googleUser.getAuthResponse().id_token).then(() => {
                        resolve()
                    })
                }, function (error) {
                    context.commit(SET_GOOGLE_LOGIN_STATE, {
                        state: LOADING_COMPLETED_FAILURE,
                        data: null,
                        error: error,
                    })
                    reject(error)
                })
            })
        },
        [LOGIN_WITH_GOOGLE]: (context, payload) => {
            const tokenObj = {
                token: payload
            }

            return http.post(`sessions/google`, tokenObj).then(response => {
                console.log(response.data)
                if (response.data.success) {
                    context.commit(SET_SESSION, {
                        state: LOADING_COMPLETED_SUCCESS,
                        data: response.data.token,
                        error: null,
                    })
                    context.commit(SET_GOOGLE_LOGIN_STATE, {
                        state: LOADING_COMPLETED_SUCCESS,
                        data: null,
                        error: null,
                    })
                } else {

                    throw new Error('Unsuccessful Google Login')
                }
            }).catch(err => {
                console.log(err)
                context.commit(SET_GOOGLE_LOGIN_STATE, {
                    state: LOADING_COMPLETED_FAILURE,
                    data: null,
                    error: err.message,
                })
            })
        },
        [AUTHENTICATE_WITH_FACEBOOK]: (context, payload) => {
            return new Promise(function (resolve, reject) {
                context.commit(SET_FACEBOOK_LOGIN_STATE, {
                    state: LOADING_STARTED,
                    data: null,
                    error: null,
                })
                const tokenObj = {
                    token: payload
                }
                context.state.facebook.facebookSdk.data.login(function (response) {
                    if (response.authResponse && response.authResponse.accessToken) {
                        return context.dispatch(LOGIN_WITH_FACEBOOK, response.authResponse.accessToken).then(() => {
                            resolve()
                        })

                    } else {
                        const err = new Error('User cancelled login or did not fully authorize.')
                        context.commit(SET_FACEBOOK_LOGIN_STATE, {
                            state: LOADING_COMPLETED_FAILURE,
                            data: null,
                            error: err.message,
                        })
                        reject(err)
                    }
                }, {
                    scope: 'email'
                });
            })
        },
        [LOGIN_WITH_FACEBOOK]: (context, payload) => {
            context.commit(SET_FACEBOOK_LOGIN_STATE, {
                state: LOADING_STARTED,
                data: null,
                error: null,
            })
            const tokenObj = {
                token: payload
            }

            return http.post(`sessions/facebook`, tokenObj).then(response => {
                console.log(response.data)
                if (response.data.success) {
                    context.commit(SET_SESSION, {
                        state: LOADING_COMPLETED_SUCCESS,
                        data: response.data.token,
                        error: null,
                    })
                    context.commit(SET_FACEBOOK_LOGIN_STATE, {
                        state: LOADING_COMPLETED_SUCCESS,
                        data: null,
                        error: null,
                    })
                } else {
                    throw new Error('Unsuccessful Facebook Login')
                }
            }).catch(err => {
                context.commit(SET_FACEBOOK_LOGIN_STATE, {
                    state: LOADING_COMPLETED_FAILURE,
                    data: null,
                    error: err.message,
                })
            })
        },
    }
}

export default integrationsModule
export {integrationsModule}